/**
 * 投放域「主表单弹窗」的共享布局 —— 投放产品 / 落地页任务 / 投放计划三个弹窗同款。
 *
 * 这几个弹窗运营是连着用的（先建产品、再建任务、再排计划），宽度或标签列差一点就看得出来。
 * 此前各写各的字面量，改一处别处不会跟着动，已经漂出过 800/140、640/140 两种。
 * 放这里是为了「改一处处处都变」，不是为了少打几个字。
 *
 * 只收表单型主弹窗：确认框、详情抽屉、文案编辑器的宽度按各自内容定，不套这套值。
 */

import { type FormRowProps, FormRow as UiFormRow } from '~/ui/FormRow';

/** Dialog 宽度（px） */
export const LANDING_FORM_DIALOG_WIDTH = 860;

/** 标签列固定宽（px）—— 够放「投放页域 base_url」这类最长标签而不折行 */
const LABEL_WIDTH = 150;

export const LandingFormRow = (p: FormRowProps) => (
  <UiFormRow labelWidth={LABEL_WIDTH} gap={14} pad="12px 0" labelPadTop={6} {...p} />
);
